<div class="menu no-selected-catalog" *ngIf="catalogs.length === null">No currently selected catalog</div>

<perfect-scrollbar>
  <div class="menu" *ngIf="catalogs.length" id="select-menu">
    <div class="card">
      <div role="tab" class="card-header">
        <h5>
          <button class="btn btn-link" (click)="goToBookmarkPage()">
            <div class="tab">
              <span class="icon"><i class="fa fa-star"></i></span>
              <span>{{ 'ALL_MY_SAVED_ITEMS' | translate }}</span>
              <span class="bookmark-count" *ngIf="bookmarkCount > 0">{{ bookmarkCount }}</span>
            </div>
          </button>
        </h5>
      </div>
    </div>

    <div *ngIf="userFeeds.length" class="card">
      <div role="tab" class="card-header">
        <h5>
          <button class="btn btn-link" (click)="goToAddFeedPage()">
            <div class="tab">
              <span class="icon"><i class="fa fa-plus"></i></span>
              <span>{{ 'CUSTOMIZE_THE_PLATFORM' | translate }}</span>
            </div>
          </button>
        </h5>
      </div>
    </div>

    <div *ngIf="!userFeeds.length" class="no-feed">
      <p>{{ 'MENU_ADD_FEED_WELCOME_TEXT' | translate }}</p>
    </div>

    <ngb-accordion #acc="ngbAccordion" [closeOthers]="true">
      <ng-container *ngFor="let feed of userFeeds; let i = index">
        <ngb-panel class="feed" *ngIf="isVisibleFeed(userFeeds, feed)">
          <ng-template ngbPanelTitle>
            <div class="tab" (click)="getFolders(feed)" [class.feed-current]="feed.id === currentFeedId">
              <span class="icon"><i class="fa fa-chevron-right"></i></span>
              <span class="title">{{ feed.name[lang] }}</span>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <ul class="feed_page-list">
              <li
                class="feed_page"
                *ngFor="let page of pages$ | async"
                [class.feed_page-current]="feed.id === currentFeedId && page.type === currentPageType"
                (click)="goToPage(feed, page)"
              >
                <ng-container [ngSwitch]="page.type">
                  <span class="icon" *ngSwitchCase="'dashboard'"><i class="fa fa-home"></i></span>
                  <span class="icon" *ngSwitchCase="'radar'"><i class="fa fa-circle-o"></i></span>
                  <span class="icon" *ngSwitchCase="'afprelax'"><i class="fa fa-pencil"></i></span>
                  <span class="icon" *ngSwitchCase="'reader'"><i class="fa fa-comment-o"></i></span>
                  <span class="icon" *ngSwitchCase="'calendar'"><i class="fa fa-calendar"></i></span>
                  <span class="icon" *ngSwitchDefault><i class="fa fa-folder-o"></i></span>
                </ng-container>
                <a class="menu-link">{{ page.label }}</a>
              </li>
              <ng-container *ngFor="let search of searchListItems">
                <li class="search-link feed_page" *ngIf="search.context.feed === feed.slug">
                  <div
                    class="menu-link search"
                    [routerLink]="['./', 'select', 'feed', feed.slug, search.context.page, lang]"
                    [queryParams]="{ search: search.filter, searchId: search.id }"
                  >
                    <span class="search-icon"><i class="fa fa-star-o"></i></span>
                    <span class="search-description">{{ search.title }}</span>
                  </div>
                  <div class="search-btn">
                    <app-search-btn [type]="'menu'" [savedSearch]="search"></app-search-btn>
                  </div>
                </li>
              </ng-container>
              <ng-container *ngIf="folders$ | async as folders; else loadingFolders">
                <ng-container *ngFor="let folder of folders[feed.slug]; let i = index">
                  <li
                    class="feed_page"
                    *ngIf="folder.lang === lang"
                    [ngClass]="{ first: i === 0 }"
                    [class.feed_page-current]="
                      feed.id === currentFeedId && folder.folder_id === currentFolderId && currentPageType === 'folder'
                    "
                    (click)="goToFolderPage(folder.folder_id)"
                  >
                    <span class="icon"><i class="fa fa-folder-o"></i></span>
                    <a class="menu-link">{{ folder.title }}</a>
                  </li>
                </ng-container>
              </ng-container>
              <ng-template #loadingFolders>
                <li class="preloading">
                  <span class="icon">
                    <i class="fa fa-spinner" aria-hidden="true"></i>
                  </span>
                </li>
              </ng-template>
            </ul>
          </ng-template>
        </ngb-panel>
      </ng-container>
    </ngb-accordion>

    <div *ngIf="userFeeds.length" class="card last">
      <div role="tab" class="card-header">
        <h5>
          <button class="btn btn-link">
            <div class="tab">
              <span class="icon"><i class="fa fa-pencil"></i></span>
              <span (click)="goToOnDemandPage()">{{ 'ORDER_ON_DEMAND' | translate }}</span>
            </div>
          </button>
        </h5>
      </div>
    </div>

    <div class="main-menu-footer-logo">
      <img
        class="logo-relaxnews"
        src="assets/images/logos/menu-footer-logo/relaxnews.svg"
        alt="logo Relaxnews"
        title="logo Relaxnews"
      />
      <img
        class="logo-publicis"
        src="assets/images/logos/menu-footer-logo/publicis-media.svg"
        alt="logo Publicis Media"
        title="logo Publicis Media"
      />
      <img class="logo-afp" src="assets/images/logos/menu-footer-logo/AFP.png" alt="logo AFP" title="logo AFP" />
    </div>
  </div>
</perfect-scrollbar>
